module.exports = __webpack_public_path__ + "img/rec.d92eecb6.svg";